import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

interface IStatTileProps {
  label: string;
  value: string | number | null;
  loading: boolean;
  error: string | null;
  suffix?: string;
}

const StatTile = ({ label, value, loading, error, suffix }: IStatTileProps) => {
  return (
    <Box className="statTile">
      {loading && <CircularProgress size={20} sx={{ color: '#07553d' }} />}

      {!loading && error && (
        <Typography variant="body2" color="#aa1418">
          {error}
        </Typography>
      )}

      {!loading && !error && (
        <Typography variant="h4" className="statTileValue" color="#07553d" fontWeight="bold">
          {value}
          {suffix}
        </Typography>
      )}

      <Typography variant="subtitle2" className="statTileLabel">
        {label}
      </Typography>
    </Box>
  );
};

export default StatTile;